import React from 'react'
import KYCManagement from '../components/admin/KYCManagement'

const AdminKYC: React.FC = () => {
  return <KYCManagement />
}

export default AdminKYC